<template>
  <v-list-item v-if="userHasRequiredRoles" :to="pageLink" active-class="active-menu-item"
               @click="click">
    <v-list-item-action v-if="miniMenu">
      <template v-if="!miniMenu">
        <!--<v-icon  class="page-icon secondary--text">{{ page.icon }}</v-icon>-->
      </template>

      <v-tooltip v-else right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="page-icon secondary--text" v-bind="attrs" v-on="on">{{ page.icon }}</v-icon>
        </template>
        <span>{{ page.title }}           <div v-if="page.unread" class="d-inline-block unread-badge">
            <v-badge
                dot color="error"
            ></v-badge>
          </div></span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title class="page-title d-flex justify-space-between align-center secondary--text">

        <div>{{ page.title }}
          <div v-if="page.unread" class="d-inline-block unread-badge">
            <v-badge
                dot color="error"
            ></v-badge>
          </div>
        </div>

        <div v-if="page.count !== undefined && page.count() > 0" style="min-width: 25px;">
          <v-badge :content="page.count()" color="secondary"></v-badge>
        </div>
        <template v-if="page.requiresProOrHigher && !$isPaidTenant">
          <plan-chip :plan="$t('tenants.statuses.PRO')"/>
        </template>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import PlanChip from '@/components/Tenant/Reports/PlanChip';

export default {
  components: {PlanChip},
  props: ['page', 'miniMenu'],
  name: 'PageLink',
  methods: {
    click() {
      this.$emit('click');
    },
  },
  computed: {
    userHasRequiredRoles() {
      if (this.page.tenantRoles && this.page.tenantRoles.length > 0) {
        return this.$hasMatchingTenantRoles(this.page.tenantRoles);
      } else if (this.page.roles && this.page.roles.length > 0) {
        return this.$hasMatchingRoles(this.page.roles);
      }
      return true;
    },
    pageLink() {
      const page = this.page;
      const link = {
        name: page.link,
      };

      if ('params' in page) {
        link.params = page.params();
      }
      return link;
    },
  },
};
</script>

<style lang="scss" scoped>
.unread-badge {
  top: -10px;
  position: relative;
}

.page-title {
  font-weight: normal !important;
}

.active-menu-item {
  .page-title,
  .page-icon--text {
    color: var(--v-accent5-base) !important;
    caret-color: var(--v-accent5-base) !important;
  }

  &:before {
    opacity: 0;
  }
}
</style>
